module.exports = __webpack_public_path__ + "img/screen-pariciones.d130784f.png";